export default __webpack_public_path__ + "static/media/Group1497TataNeu.75a31214.png";